export default __webpack_public_path__ + "static/media/Icon11_On.f7f98c23.png";